import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import UnauthorizedView from '../components/UnauthorizedView';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/unauthorized" element={<UnauthorizedView />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
};

export default AppRoutes;